import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-169474a3")

_pushScopeId("data-v-169474a3")
const _hoisted_1 = { class: "overlay state-age" }
const _hoisted_2 = { class: "t-6 stat-age__title" }
const _hoisted_3 = { class: "state-age__body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "state-age__graphic-pie" }, [
  /*#__PURE__*/_createVNode("div", { class: "state-age__divchartpie" })
], -1)
const _hoisted_5 = { class: "state-age__legends" }
const _hoisted_6 = { class: "state-age__legend-title" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "state-age__marker" }, null, -1)
const _hoisted_8 = { class: "state-age__quantity" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('touchbord.TouristAge')), 1),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.dataToLegend, (item, itemInd) => {
          return (_openBlock(), _createBlock("div", {
            key: item,
            class: "state-age__legend"
          }, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(item.ageGroup + _ctx.$t($setup.getAgeRangeTranslate($setup.dataToLegend.length, itemInd))), 1 /* TEXT */)
            ]),
            _createVNode("div", _hoisted_8, _toDisplayString(item.percentage), 1)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})